import {
    authenticateDebtorRequest,
    accessPageInfoRequest,
    loadDealInstallmentsInformationRequest,
} from 'src/repositories/debtor-area.repository';

import { 
    simulateDebtRequest
} from 'src/repositories/debt.repository';

import {
    createDealRequest,
    processManualPayment
} from 'src/repositories/deal.repository';

/**
 * Action Types
 */

export const SETTED_DEBTOR_PARAMS = 'SETTED_DEBTOR_PARAMS';

export const SETTED_DEAL = 'SETTED_DEAL';

export const SETTED_OFFER_BAR = 'SETTED_OFFER_BAR';

export const LOADED_DEAL_INSTALLMENTS_INFORMATION = 'LOADED_DEAL_INSTALLMENTS_INFORMATION';

export const ACCESS_PAGE_INFO_RETRIEVED = 'ACCESS_PAGE_INFO_RETRIEVED';
export const ACCESS_PAGE_INFO_LOADING = 'ACCESS_PAGE_INFO_LOADING';

export const DEBTOR_AUTHENTICATED = 'DEBTOR_AUTHENTICATED';

export const DEAL_CREATE_LOADING = 'DEAL_CREATE_LOADING';
export const DEAL_CREATED = 'DEAL_CREATED';

export const SETTED_SELECTED_INSTALLMENTS = 'SETTED_SELECTED_INSTALLMENTS';

export const SETTED_SELECTED_DEBT = 'SETTED_SELECTED_DEBT';

export const SIMULATING_DEBT_LOADING = 'SIMULATING_DEBT_LOADING';
export const SIMULATED_DEBT = 'SIMULATED_DEBT';
export const DEBT_SIMULATION_DATE_CHANGED = 'DEBT_SIMULATION_DATE_CHANGED';

export const DEBT_INSTALLMENTS_SELECTED_CHANGED = 'DEBT_INSTALLMENTS_SELECTED_CHANGED';

export const PAYMENT_TYPE_CHANGED = 'PAYMENT_TYPE_CHANGED';

/**
 * Action Creators
 */

export const settedDebtorParams = (document, token, action) => ({
    type: SETTED_DEBTOR_PARAMS,
    payload: {
        document,
        token,
        action,
    },
});

export const settedDeal = deal => ({
    type: SETTED_DEAL,
    payload: deal,
});

export const settedOfferBar = offerBar => ({
    type: SETTED_OFFER_BAR,
    payload: offerBar,
});

export const loadedDealInstallmentsInformation = rule => ({
    type: LOADED_DEAL_INSTALLMENTS_INFORMATION,
    payload: rule,
});

export const debtorAuthenticated = debtor => ({
    type: DEBTOR_AUTHENTICATED,
    payload: debtor,
});

export const accessPageInfoLoading = isLoading => ({
    type: ACCESS_PAGE_INFO_LOADING,
    payload: isLoading,
});

export const accessPageInfoRetrieved = accessPageInfo => ({
    type: ACCESS_PAGE_INFO_RETRIEVED,
    payload: accessPageInfo,
});

export const dealCreateLoading = isLoading => ({
    type: DEAL_CREATE_LOADING,
    payload: isLoading,
});

export const dealCreated = deal => ({
    type: DEAL_CREATED,
    payload: deal,
});

export const settedSelectedInstallments = installments => ({
    type: SETTED_SELECTED_INSTALLMENTS,
    payload: installments,
});

export const settedSelectedDebt = debt => ({
    type: SETTED_SELECTED_DEBT,
    payload: debt,
});

export const simulatingDebtLoading = loading => ({
    type: SIMULATING_DEBT_LOADING,
    payload: loading,
});

export const simulatedDebt = debt => ({
    type: SIMULATED_DEBT,
    payload: debt,
});

export const debtSimulationDateChanged = date => ({
    type: DEBT_SIMULATION_DATE_CHANGED,
    payload: date,
});

export const debtInstallmentsSelectedChanged = debtInstallmentsIndexes => ({
    type: DEBT_INSTALLMENTS_SELECTED_CHANGED,
    payload: debtInstallmentsIndexes,
});

export const changedPaymentType = paymentType => ({
    type: PAYMENT_TYPE_CHANGED,
    payload: paymentType,
});

/**
 * Actions
 */


/**
 * Set debtor document and token
 * @param {string} document
 * @param {string} token
 */
export const setDebtorParams = (document, token, action) => dispatch => dispatch(settedDebtorParams(document, token, action));

/**
 * Set deal
 * @param {object} deal
 */
export const setDeal = deal => dispatch => dispatch(settedDeal(deal));

/**
 * Set offer bar
 * @param {object} deal
 */
export const setOfferBar = offerBar => dispatch => dispatch(settedOfferBar(offerBar));

/**
 * Set installment offer rule
 * @param {object} deal
 */
export const loadDealInstallmentsInformation = params => dispatch => loadDealInstallmentsInformationRequest(params)
    .then(response => dispatch(loadedDealInstallmentsInformation(response.data)));

/**
 * Retrieve debtor area information
 * @param {string} token
 */
export const retrieveAccessPageInfo = (token, action) => (dispatch) => {
    dispatch(accessPageInfoLoading(true));
    return accessPageInfoRequest(token, action)
        .then(({ data }) => {
            dispatch(accessPageInfoRetrieved(data));
        })
        .finally(() => dispatch(accessPageInfoLoading(false)));
};

export const simulateDebt = (pkDebt, due) => dispatch => {
    dispatch(debtSimulationDateChanged(due));
    dispatch(simulatingDebtLoading(true));
    return simulateDebtRequest(pkDebt, due.format('YYYY-MM-DD'))
        .then(({ data }) => {
            dispatch(simulatedDebt(data));
        })
        .finally(() => dispatch(simulatingDebtLoading(false)));
};

export const changeSimulationDate = (due) => dispatch => dispatch(debtSimulationDateChanged(due));

/**
 * Authenticated debtor
 * @param {string} token
 * @param {string} document
 */
export const authenticateDebtor = (token, document, action = null, refreshing = false) => dispatch => authenticateDebtorRequest(token, document, action, refreshing)
    .then(({ data }) => dispatch(debtorAuthenticated(data)));

/**
 * Generate deal from selected installments
 * @param {object} params
 */
export const createDeal = params => (dispatch) => {
    dispatch(dealCreateLoading(true));
    return createDealRequest(params)
        .then(({ data }) => dispatch(dealCreated(data)))
        .finally(() => dispatch(dealCreateLoading(false)));
};


// manual payment
export const manualPayment = params => {
    return processManualPayment(params).then(({response}) => console.log(response));
};

/**
 * Set how much installments user setted on deal installments
 * @param {number} installments
 */
export const setSelectedInstallments = installments => dispatch => dispatch(settedSelectedInstallments(installments));

/**
 * Set selected debt
 * @param {number} installments
 */
export const setSelectedDebt = debt => dispatch => dispatch(settedSelectedDebt(debt));

export const setDebtSelectedInstallments = installmentsIndexes => dispatch => dispatch(debtInstallmentsSelectedChanged(installmentsIndexes));

export const setPaymentType = paymentType => dispatch => dispatch(changedPaymentType(paymentType));